(function () {
  var CART_INSTALLMENT_MODAL_IDS = [
    "installment-detail-modal-cart-drawer",
    "installment-detail-modal-cart-template",
  ];

  function getModal(modalId) {
    if (!modalId) return null;
    return document.getElementById(modalId);
  }

  var lastFocusedElement = null;
  var modalWithTemporaryTabindex = null;

  function focusModal(modal) {
    var focusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) {
      focusable.focus();
      return;
    }
    if (!modal.hasAttribute("tabindex")) {
      modal.setAttribute("tabindex", "-1");
      modalWithTemporaryTabindex = modal;
    }
    modal.focus();
  }

  function showProvider(modal, providerIndex) {
    modal.querySelectorAll("[data-installment-provider-panel]").forEach(function (panel) {
      panel.hidden =
        String(panel.getAttribute("data-installment-provider-panel")) !== String(providerIndex);
    });
  }

  function openModal(modalId, providerIndex) {
    var modal = getModal(modalId);
    if (!modal) return;
    lastFocusedElement = document.activeElement;
    showProvider(modal, providerIndex);
    modal.hidden = false;
    modal.style.display = "flex";
    document.body.classList.add("modal-open");
    focusModal(modal);
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.style.display = "none";
    document.body.classList.remove("modal-open");
    if (modalWithTemporaryTabindex === modal) {
      modal.removeAttribute("tabindex");
      modalWithTemporaryTabindex = null;
    }
    if (lastFocusedElement && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus();
    }
  }

  function formatInstallmentMoney(cents) {
    var normalized = Number.isFinite(Number(cents)) ? Number(cents) : 0;
    if (
      window.theme &&
      theme.Currency &&
      typeof theme.Currency.formatMoney === "function"
    ) {
      return theme.Currency.formatMoney(normalized, theme.moneyFormat)
        .replace(/([,.]00)(?!\d)/, "")
        .replace(".", " ");
    }
    return (normalized / 100).toFixed(2).replace(/\.00$/, "").replace(".", " ");
  }

  function calculateInstallmentTotal(baseCents, interestValue) {
    var base = Number(baseCents || 0);
    var interest = Number(interestValue || 0);
    if (!Number.isFinite(base) || base < 0) return 0;
    if (!Number.isFinite(interest) || interest <= 0) return Math.round(base);
    return Math.round(base + (base * interest) / 100);
  }

  function calculateInstallmentMonthly(baseCents, termValue, interestValue) {
    var term = Number(termValue || 0);
    if (!Number.isFinite(term) || term <= 0) return 0;
    var total = calculateInstallmentTotal(baseCents, interestValue);
    return Math.round(total / term);
  }

  function updateRowTextsInBnpBox(bnpBox, baseCents) {
    bnpBox.querySelectorAll(".pdp-installment-modal__row-text[data-original-text]").forEach(function (row) {
      var tpl = row.getAttribute("data-original-text") || "";
      if (!tpl) return;
      var numStr = row.getAttribute("data-installment-num");
      var monthlyCents = baseCents;
      if (numStr) {
        var n = parseInt(numStr, 10);
        if (Number.isFinite(n) && n > 0) {
          monthlyCents = Math.round(baseCents / n);
        }
      }
      var formatted = formatInstallmentMoney(monthlyCents);
      row.innerHTML = tpl.replace(/\[price\]/g, formatted);
    });
  }

  function syncPayPalMainFromBnpBox(bnpBox, baseCents) {
    var main = bnpBox.closest(".PayPal_box_content_main");
    if (!main) return;
    main.querySelectorAll("klarna-placement").forEach(function (k) {
      k.setAttribute("data-purchase-amount", String(baseCents));
    });
    main.querySelectorAll("[data-pp-message]").forEach(function (pp) {
      pp.setAttribute("data-pp-amount", String(baseCents / 100.0));
    });
    main.querySelectorAll(".affirm-as-low-as[data-amount], .affirm-message-item[data-amount]").forEach(function (a) {
      a.setAttribute("data-amount", String(baseCents));
    });
  }

  function updateDetailModal(modal, baseCents) {
    modal.querySelectorAll(".pdp-installment-detail-modal__item[data-installment-term]").forEach(function (item) {
      var term = parseInt(item.getAttribute("data-installment-term"), 10);
      var interest = parseFloat(item.getAttribute("data-installment-interest"));
      var monthly = calculateInstallmentMonthly(baseCents, term, interest);
      var total = calculateInstallmentTotal(baseCents, interest);
      var strongEl = item.querySelector(".pdp-installment-detail-modal__monthly strong");
      var totalEl = item.querySelector("[data-installment-total-display]");
      if (strongEl) strongEl.textContent = formatInstallmentMoney(monthly);
      if (totalEl) totalEl.textContent = formatInstallmentMoney(total);
    });
  }

  function applyCartInstallmentCents(baseCents) {
    var cents = Number(baseCents);
    if (!Number.isFinite(cents) || cents < 0) return;
    CART_INSTALLMENT_MODAL_IDS.forEach(function (modalId) {
      var modal = document.getElementById(modalId);
      if (modal) updateDetailModal(modal, cents);
      document
        .querySelectorAll('.bnp-container[data-installment-modal-id="' + modalId + '"]')
        .forEach(function (box) {
          updateRowTextsInBnpBox(box, cents);
          var bnpRow = box.querySelector(".pdp-installment-modal__row[data-bnp-price]");
          if (bnpRow) bnpRow.setAttribute("data-bnp-price", String(cents));
          syncPayPalMainFromBnpBox(box, cents);
        });
    });
  }

  function refreshCartInstallmentFromFetch() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartInstallmentCents(cart.total_price);
      })
      .catch(function () {});
  }

  document.addEventListener("installment:cart-sync", function (e) {
    var c = e && e.detail && e.detail.totalPriceCents;
    if (typeof c === "number" && Number.isFinite(c)) {
      applyCartInstallmentCents(c);
      return;
    }
    refreshCartInstallmentFromFetch();
  });

  var fetchPatched = false;
  function patchFetchForCartInstallmentSync() {
    if (fetchPatched || typeof window.fetch !== "function") return;
    fetchPatched = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function () {
      var args = arguments;
      return nativeFetch.apply(void 0, args).then(function (response) {
        try {
          var url = typeof args[0] === "string" ? args[0] : args[0] && args[0].url;
          if (
            url &&
            /\/cart\/(update|change|add|clear)\.js(\?|$)/.test(String(url)) &&
            response.ok
          ) {
            response
              .clone()
              .json()
              .then(function () {
                document.dispatchEvent(new CustomEvent("installment:cart-sync"));
              })
              .catch(function () {});
          }
        } catch (err) {}
        return response;
      });
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    patchFetchForCartInstallmentSync();
    refreshCartInstallmentFromFetch();
  });

  document.addEventListener("click", function (event) {
    var openBtn = event.target.closest("a.openInstallmentDetailBtn");
    if (openBtn) {
      event.preventDefault();
      var providerIndex = Number(openBtn.getAttribute("data-installment-provider") || 1);
      var modalId = openBtn.getAttribute("data-installment-modal-id");
      openModal(modalId, providerIndex);
      return;
    }

    var fallbackTrigger = event.target.closest("[data-installment-provider] a");
    if (fallbackTrigger) {
      var row = fallbackTrigger.closest("[data-installment-provider]");
      var container = fallbackTrigger.closest("[data-installment-modal-id]");
      if (!container) return;
      event.preventDefault();
      var provider = row ? Number(row.getAttribute("data-installment-provider") || 1) : 1;
      openModal(container.getAttribute("data-installment-modal-id"), provider);
      return;
    }

    var closeBtn = event.target.closest(".js-installment-detail-close");
    if (closeBtn) {
      var modal = closeBtn.closest(".js-installment-detail-modal");
      if (!modal) return;
      closeModal(modal);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var openedModal = document.querySelector(".js-installment-detail-modal:not([hidden])");
    if (!openedModal) return;
    event.preventDefault();
    closeModal(openedModal);
  });
})();
